<script>
import {types} from '../data'

export default {
  name: 'TechnologyNav',
  props: {
    value: {
      type: String | Number,
      required: true
    }
  },
  data() {
    return {
      types,
    }
  },
  methods: {
    handleClick(item) {
      if (this.$parent.$refs.TechnologyList.listState.loading) return
      this.$emit('input', item.value)
    }
  }
}
</script>

<template>
  <div class="flex-nav">
    <div
      v-for="item in types"
      :key="item && item.value"
      class="nav-txt"
      :class="value === item.value ? 'cur' : ''"
      @click="handleClick(item)"
      v-track="{ functionName: `新技术-${item.label}` }"
    >
      {{ item && item.label }}
      <img src="@/assets/images/technology/img2.png" v-if="value === item.value" class="icon1" alt=""/>
    </div>
  </div>
</template>

<style scoped lang="less">
.flex-nav {
  border-radius: 12px;
  display: flex;
  align-items: center;
  padding: 0 15px 15px;
  height: 29px;
  position: sticky;
  left: 0;
  top: 54px;
  background: #F7F9FB;
  z-index: 999;

  .nav-txt {
    font-size: 16px;
    color: #333333;
    font-weight: 400;
    box-sizing: border-box;
    position: relative;
    height: 42px;
    display: flex;
    align-items: center;
    white-space: nowrap;
    cursor: pointer;
    margin-right: 20px;

    .icon1 {
      width: 25px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 3px;
    }

    &.cur {
      font-family: Alibaba PuHuiTi 3.0;
      font-size: 18px;
      font-weight: bold;
      color: #3D3D3D;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/technology/modules/TechnologyNav.vue